//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { AnalysisStatusIdEnum } from 'config/enums'

const getAnalysisStatusColor = analysisStatusId => {
  switch (analysisStatusId) {
    case null :
      return 'text-grey-blue'

    case AnalysisStatusIdEnum.WAITING :
      return 'text-blue'

    case AnalysisStatusIdEnum.RUNNING :
      return 'text-blue'

    case AnalysisStatusIdEnum.COMPLETED :
      return 'text-green'

    case AnalysisStatusIdEnum.FAILED :
      return 'text-red'

    case AnalysisStatusIdEnum.STALE :
      return 'text-brown'

    default :
      return 'bg-red'
  }
}

export default getAnalysisStatusColor
